import React, { FunctionComponent, useEffect, useState } from 'react';
import SliderTitleOffer from './SliderTitleOffer';
import { useSelector } from 'react-redux';
import carConfigurationSelectors from '../../../../../store/selectors/carConfigurationSelectors';
import currentDealSelectors from '../../../../../store/selectors/currentDealSelectors';
import usePlatformConfig from '../../../../../../common/react/usePlatformConfig';
import useStockUrl from '../../../../../react/navigation/useStockUrl';
import stringUtilities from '../../../../../../../../common/utilities/stringUtilities';
import { getVariantDetails } from '../../../../../store/selectors/variantDetailsSelectors';

const SliderTitleOfferContainer: FunctionComponent = () => {
  const modelTitle: string = useSelector(carConfigurationSelectors.getConfigurationModelTitle);
  const configurationTitle: string = useSelector(carConfigurationSelectors.getConfigurationTitle);
  const sanitizedVariantTitle = stringUtilities.sanitizeVariantName(modelTitle, configurationTitle);
  const totalPrice = useSelector(currentDealSelectors.getPrimaryPrice);
  const { marketingLabel } = useSelector(getVariantDetails) || {};
  const [hasOffer, setHasOffer] = useState(false);
  const {
    platformConfig: { priceDisplay, stockPage, isComplexModel },
  } = usePlatformConfig();
  const { listUrl } = useStockUrl();

  useEffect(() => {
    setHasOffer(totalPrice?.distributionPrice > 0 && totalPrice?.originalPrice !== null);
  }, [totalPrice]);

  return (
    <SliderTitleOffer
      stockLink={{
        label: 'spc.stock.availableStock',
        url: listUrl,
      }}
      hasStock={stockPage}
      modelName={modelTitle}
      marketingLabel={marketingLabel}
      variantName={sanitizedVariantTitle}
      hasOffer={hasOffer}
      driveawayPrice={totalPrice?.basePrice}
      distributionPrice={totalPrice?.distributionPrice}
      currency={priceDisplay?.primary?.currency}
      decimalScale={priceDisplay?.primary?.decimalScale}
      isComplexModel={isComplexModel}
      // @TODO: Add value for engine and specPacks if complex model
    />
  );
};

export default SliderTitleOfferContainer;
